module.exports = __webpack_public_path__ + "img/fad.0d964e0d.png";